<template>
  <el-dialog
    :title="$t('lang.loginRemainder')"
    :visible.sync="dialogVisible"
    :append-to-body="true"
    :modal-append-to-body="true"
    :show-close="false"
    :center="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="30%"
    @open="openDialog">
    <div
      class="waiting"
      v-if="!isRejected"
      key="waiting">
      <p>{{$t('lang.loginRemainderWaitingTip1')}}</p>
      <p>{{$t('lang.loginRemainderWaitingTip2')}}</p>
      <div class="dialog-footer">{{timeNum+'s'}}</div>
    </div>
    <div
      class="rejected"
      v-else
      key="rejectde">
      <p><img
        src="./../assets/img/warning.svg"
        alt="">{{$t('lang.loginRemainderRejectTip')}}</p>
    </div>
  </el-dialog>
</template>

<script>
import createWS from '@/assets/js/userserviceWS'
import Bus from '@/assets/js/vueBus'
import { getUrlParam } from '@/assets/js/utils'
export default {
  name: 'LoginRemainder',
  props: {
    dialogVisible: {
      type: Boolean,
      default: true
    },
    session: {
      type: String
    }
  },
  emits: ['update:dialogVisible'],
  data () {
    return {
      // dialogVisible:true,
      websocket: null,
      timeNum: 70,
      timer: null,
      isRejected: false
    }
  },
  mounted () {
    Bus.$on('other-login', (event) => {
      if (event.agree == 2) {
        this.isRejected = true
      }
      this.websocket.close()
      clearInterval(this.timer)
      this.$emit('otherLogin', event)
    })
  },
  beforeDestroy () {
    Bus.$off('other-login')
  },
  computed: {
    websocketUrl () {
      return this.$store.state.websocketUrl
    }
  },
  methods: {
    openDialog () {
      this.connectWs()
    },
    /**
     * @Description: 创建连接websocket并倒计时70s
     * @User: aaronzhai <aaronzhai@tvunetworks.com>
     * @Date: 2021-06-10 10:30:05
     * @param {*}
     * @return {*}
     */
    connectWs () {
      const protocol = window.location.protocol === 'https:' ? 'wss' : 'ws'
      const url = `${protocol}://${this.websocketUrl}/pageSerBusRequest?taskId=${this.session}&notCheckUser=${true}&businessId=${this.session}ug:oneLogin`

      this.websocket = createWS(url)
      this.timeNum = 70
      this.timer = setInterval(() => {
        this.timeNum--
        if (this.timeNum == 0) {
          clearInterval(this.timer)
          const params = {
            serverName: 'General Management',
            data: JSON.stringify({
              module: 'afterTimeout',
              data: JSON.stringify({
                serverName: getUrlParam('serviceName'),
                session: this.session,
                businessId: this.session + 'ug:oneLogin'
              })
            })
          }

          this.websocket.send(params)
        }
      }, 1000)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.dialog-footer {
  height: 100px;
  text-align: center;
  line-height: 100px;
}
.rejected {
  margin-bottom: 40px;
  text-align: center;
  img {
    vertical-align: middle;
    margin-right: 4px;
  }
}
</style>
